import { cn } from "../shared/ui/index.ts";
import { appOpenMessageConversation } from "../core/app-bridge.ts";
import { usePractice } from "../core/providers/practice.provider.tsx";
import { patientsService } from "../core/services/patients.service.ts";
import { MESSAGE_CONVERSATIONS } from "../messages/conversations.ts";
import { PatientAvatar } from "../shared/patient/patient-avatar.component.tsx";

const DASHBOARD_CONVERSATIONS = MESSAGE_CONVERSATIONS.slice(0, 5);

export function MessagesWidget() {
  const { practice } = usePractice();

  return (
    <div className="flex flex-col gap-0.5">
      {DASHBOARD_CONVERSATIONS.map((m) => (
        <button
          key={m.id}
          type="button"
          onClick={() => appOpenMessageConversation(m.id)}
          className={cn(
            "grid w-full cursor-pointer grid-cols-[32px_1fr_auto] items-center gap-2.5 rounded-md border-0 px-2 py-2.5 text-left font-[inherit]",
            m.unread > 0
              ? "bg-sf-primary-50 hover:bg-sf-primary-100"
              : "bg-transparent hover:bg-[#f9fafb]",
          )}
        >
          {(() => {
            const p = patientsService.findByName(m.name, practice.uuid);
            return p ? (
              <PatientAvatar patient={p} size={32} />
            ) : (
              <div
                className="flex size-8 shrink-0 items-center justify-center rounded-full text-[11px] font-semibold text-white"
                style={{ background: m.color }}
              >
                {m.avatar}
              </div>
            );
          })()}
          <div className="min-w-0">
            <div className="flex items-center gap-1.5">
              <span
                className={cn(
                  "text-[13px] text-sf-text",
                  m.unread > 0 ? "font-semibold" : "font-medium",
                )}
              >
                {m.name}
              </span>
              {m.unread > 0 && (
                <span className="size-1.5 shrink-0 rounded-full bg-sf-primary" />
              )}
            </div>
            <div className="truncate text-xs text-sf-text-muted">
              {m.preview}
            </div>
          </div>
          <div className="text-[11px] text-sf-text-muted">{m.time}</div>
        </button>
      ))}
    </div>
  );
}
